import React, { useState } from "react";
import KiemKeApi from "service/BaoCao/KiemKeApi";
import { pushNotification } from "../../../../../utils/notifications";

export const BtnXuatExcel = ({ item }) => {
    const [isDownloading, setIsDownloading] = useState(false);

    const handleExport = async () => {
        setIsDownloading(true);
        try {
            const response = await KiemKeApi.xuatExcelKiemKe(item.KiemKeId);
            if (response.status === 200) {
                const contentDisposition = response.headers["content-disposition"];
                let fileName = "BaoCaoKiemKeQuy.xlsx";
                if (contentDisposition) {
                    const match = contentDisposition.match(/filename="?(.+)"?/);
                    if (match && match[1]) {
                        fileName = match[1];
                    }
                }
                const url = window.URL.createObjectURL(response.data);
                const link = document.createElement("a");
                link.href = url;
                link.setAttribute("download", fileName);
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                window.URL.revokeObjectURL(url);
                pushNotification("Xuất Excel thành công!", "success", "TOP_CENTER", 2000);
            } else {
                pushNotification("Xuất Excel thất bại!", "error", "TOP_CENTER", 2000);
            }
        } catch (error) {
            console.error("Error exporting Excel:", error);
            pushNotification("Xuất Excel thất bại!", "error", "TOP_CENTER", 2000);
        } finally {
            setIsDownloading(false);
        }
    };

    return (
        <a 
            type="button" 
            className={`popover-basic ${isDownloading ? 'disabled' : ''}`} 
            onClick={!isDownloading ? handleExport : null}
            style={{ cursor: isDownloading ? 'wait' : 'pointer' }}
        >
            <img src="/app-assets/images/icon-tai-xuong-v21.png" title="Export Excel" />
        </a>
    );
};